import { DropDownOption } from '../models/drop-down-option';

export class DropDownHelper {
  static stringArrayToOptions(strings: string[]): DropDownOption[] {
    return strings.map((str) => ({
      text: str,
      value: str,
    }));
  }
}
